/* spx-cart.js
 * Extraido de sections/header-rep.liquid (bloque <script> inline SPXCart).
 * Los ajustes de la seccion viajan en window.SPX_CART_CFG.
 * Se carga SIN defer, en la misma posicion del documento, para conservar
 * exactamente el orden de ejecucion original.
 */
 (function () {
  /* Valores que antes se interpolaban con Liquid dentro de este script.
     Ahora llegan por window.SPX_CART_CFG (definido inline en
     sections/header-rep.liquid, justo antes de cargar este asset).
     Los defaults de abajo replican los del schema de la seccion. */
  var SPX_CFG_DEFAULTS = {
   free_shipping_goal: "80000",
   free_shipping_success_text: "Tienes envio gratis",
   free_shipping_pending_text: "Te faltan [amount] para envio gratis",
   show_model_selector: true,
   show_size_selector: true,
   show_fallback_selectors: true,
   max_selectors: "2",
   size_label: "Talla",
   model_label: "Modelo",
   crosssell_add_text: "Agregar",
   crosssell_sold_out_text: "Sin stock",
   show_crosssell: true,
   crosssell_limit: 4,
   crosssell_intent: "related",
   crosssell_loading_text: "Agregando...",
   crosssell_added_text: "Agregado",
   crosssell_error_text: "Error",
   empty_cart_text: "Tu carrito esta vacio."
  };

  function cfgGet(key) {
   var raw = window.SPX_CART_CFG || {};
   var value = raw[key];
   /* Solo se cae al default si el valor no existe: un false o un "" del
      merchant son valores legitimos y deben respetarse. */
   return (value === undefined || value === null) ? SPX_CFG_DEFAULTS[key] : value;
  }

  var SPXCart = window.SPXCart = window.SPXCart || {};

  function getCartRoute(path) {
   var root = '/';

   if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    root = window.Shopify.routes.root;
   }

   if (root.slice(-1) !== '/') root += '/';

   return root + String(path || '').replace(/^\//, '');
  }

  function dispatchCartFallbacks() {
   ['cart:refresh', 'cart:open', 'ajaxProduct:added', 'halo:cart:open'].forEach(function (eventName) {
    document.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
   });
  }

  function money(cents) {
   var amount = Number(cents || 0);
   try {
    return new Intl.NumberFormat('es-CL', {
     style: 'currency',
     currency: 'CLP',
     maximumFractionDigits: 0
    }).format(amount / 100);
   } catch (e) {
    return '$' + Math.round(amount / 100).toLocaleString('es-CL');
   }
  }

  function escapeHTML(value) {
   return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  }

  function normalizeText(value) {
   return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function isModelOption(name) {
   var text = normalizeText(name);
   return text.indexOf('modelo') !== -1 || text.indexOf('model') !== -1 || text.indexOf('color') !== -1 || text.indexOf('colour') !== -1 || text.indexOf('estilo') !== -1 || text.indexOf('style') !== -1;
  }

  function isSizeOption(name) {
   var text = normalizeText(name);
   return text.indexOf('talla') !== -1 || text.indexOf('size') !== -1 || text.indexOf('tamano') !== -1 || text.indexOf('tamaño') !== -1;
  }

  function getDrawer() {
   return document.querySelector('[data-spx-cart]');
  }

  function spxShowPanel(panel) {
   if (!panel) return;

   panel.hidden = false;

   window.requestAnimationFrame(function () {
    panel.classList.add('is-active');
   });

   document.body.classList.add('spx-lock');
  }

  function spxHidePanel(panel) {
   if (!panel) return;

   panel.classList.remove('is-active');

   window.setTimeout(function () {
    if (!panel.classList.contains('is-active')) {
     panel.hidden = true;
    }
   }, 260);

   document.body.classList.remove('spx-lock');
  }

  function openCart() {
   var drawer = getDrawer();
   if (drawer) {
    spxShowPanel(drawer);
   } else {
    dispatchCartFallbacks();
   }

   return renderCart();
  }

  function closeCart() {
   var drawer = getDrawer();
   if (!drawer) return;
   spxHidePanel(drawer);
  }

  function updateCartCount(cart) {
   var itemCount = typeof cart === 'number'
    ? Number(cart || 0)
    : Number((cart && cart.item_count) || 0);

   document.querySelectorAll('[data-spx-cart-count], [data-cart-count], .cart-count, .cartCount, .header__cart-count, .cart-count-bubble span').forEach(function (count) {
    count.textContent = itemCount;

    if (count.matches('[data-spx-cart-count]')) {
     count.hidden = itemCount <= 0;
    } else if (itemCount > 0 && count.hasAttribute('hidden')) {
     count.hidden = false;
     count.removeAttribute('hidden');
    }
   });

   document.querySelectorAll('[data-spx-cart-title-count]').forEach(function (titleCount) {
    titleCount.textContent = '(' + itemCount + ')';
   });
  }

  function updateFreeShipping(cart) {
   var text = document.querySelector('[data-spx-shipping-text]');
   var progress = document.querySelector('[data-spx-shipping-progress]');
   if (!text || !progress) return;

   var goal = Math.max(0, Number(cfgGet('free_shipping_goal')) || 0) * 100;
   var total = Number(cart.total_price || 0);
   var percentage = goal > 0 ? Math.min(100, Math.round((total / goal) * 100)) : 0;
   progress.style.width = percentage + '%';

   if (goal <= 0) {
    text.textContent = '';
    return;
   }

   if (total >= goal) {
    text.textContent = cfgGet('free_shipping_success_text');
   } else {
    text.textContent = cfgGet('free_shipping_pending_text').replace('[amount]', money(goal - total));
   }
  }

  function getProductOptions(product) {
   var variants = Array.isArray(product.variants) ? product.variants : [];
   if (!Array.isArray(product.options)) return [];

   return product.options.map(function (option, index) {
    if (typeof option === 'string') {
     var values = [];
     variants.forEach(function (variant) {
      var value = variant['option' + (index + 1)];
      if (!value && Array.isArray(variant.options)) value = variant.options[index];
      if (value && values.indexOf(value) === -1) values.push(value);
     });

     return {
      name: option,
      position: index + 1,
      values: values
     };
    }

    return {
     name: option.name || ('Option ' + (index + 1)),
     position: option.position || index + 1,
     values: option.values || []
    };
   });
  }

  function getVisibleOptions(product) {
   var options = getProductOptions(product);
   var modelOption = null;
   var sizeOption = null;
   var selected = [];

   options.forEach(function (option) {
    if (!modelOption && isModelOption(option.name)) modelOption = option;
    if (!sizeOption && isSizeOption(option.name)) sizeOption = option;
   });

   if (cfgGet('show_model_selector') && modelOption) selected.push(modelOption);
   if (cfgGet('show_size_selector') && sizeOption && (!modelOption || Number(sizeOption.position) !== Number(modelOption.position))) selected.push(sizeOption);

   if (selected.length === 0 && cfgGet('show_fallback_selectors')) {
    selected = options.slice(0, cfgGet('max_selectors'));
   }

   return selected.slice(0, cfgGet('max_selectors'));
  }

  function normalizeVariant(variant, product) {
   var image = '';
   if (variant.featured_image && variant.featured_image.src) image = variant.featured_image.src;
   else if (variant.image) image = variant.image;
   else if (product.featured_image) image = product.featured_image;
   else if (product.images && product.images[0]) image = product.images[0];

   return {
    id: variant.id,
    available: variant.available,
    price: variant.price,
    option1: variant.option1 || (variant.options && variant.options[0]) || null,
    option2: variant.option2 || (variant.options && variant.options[1]) || null,
    option3: variant.option3 || (variant.options && variant.options[2]) || null,
    image: image
   };
  }

  function getFirstAvailableVariant(product) {
   if (!product || !Array.isArray(product.variants)) return null;
   for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].available) return normalizeVariant(product.variants[i], product);
   }
   return product.variants[0] ? normalizeVariant(product.variants[0], product) : null;
  }

  function variantMatchesSelection(variant, selection) {
   var normalized = normalizeVariant(variant, {});
   var keys = Object.keys(selection || {});
   for (var i = 0; i < keys.length; i++) {
    var position = keys[i];
    if (String(normalized['option' + position]) !== String(selection[position])) return false;
   }
   return true;
  }

  function getSelectedCrosssellVariant(card, product) {
   var selection = {};
   var variants = Array.isArray(product.variants) ? product.variants : [];

   card.querySelectorAll('[data-spx-crosssell-option]').forEach(function (select) {
    selection[select.getAttribute('data-option-position')] = select.value;
   });

   var exact = variants.find(function (variant) {
    return variantMatchesSelection(variant, selection);
   });

   return exact ? normalizeVariant(exact, product) : getFirstAvailableVariant(product);
  }

  function optionSelectHTML(option) {
   var values = Array.isArray(option.values) ? option.values : [];
   if (values.length <= 1) return '';

   var label = isSizeOption(option.name)
    ? cfgGet('size_label')
    : isModelOption(option.name)
     ? cfgGet('model_label')
     : option.name;

   var html = '<select class="spx-crosssell__select" data-spx-crosssell-option data-option-position="' + escapeHTML(option.position) + '" aria-label="' + escapeHTML(label) + '">';
   values.forEach(function (value) {
    html += '<option value="' + escapeHTML(value) + '">' + escapeHTML(label) + ': ' + escapeHTML(value) + '</option>';
   });
   html += '</select>';
   return html;
  }

  function crosssellOptionsHTML(product) {
   var options = getVisibleOptions(product);
   if (!options.length) return '';
   var html = '<div class="spx-crosssell__options">';
   options.forEach(function (option) {
    html += optionSelectHTML(option);
   });
   html += '</div>';
   return html;
  }

  function updateCrosssellCard(card, product) {
   var variant = getSelectedCrosssellVariant(card, product);
   var button = card.querySelector('[data-spx-crosssell-add]');
   var price = card.querySelector('[data-spx-crosssell-price]');
   var image = card.querySelector('[data-spx-crosssell-image]');
   var status = card.querySelector('[data-spx-crosssell-status]');

   var addText = cfgGet('crosssell_add_text') || 'AGREGAR';
   var soldOutText = cfgGet('crosssell_sold_out_text') || 'SIN STOCK';

   if (!variant) {
    if (button) {
     button.disabled = true;
     button.setAttribute('data-spx-crosssell-add', '');
     button.textContent = soldOutText;
    }
    if (status) {
     status.hidden = false;
     status.textContent = soldOutText;
    }
    return;
   }

   if (button) {
    button.setAttribute('data-spx-crosssell-add', variant.id);
    button.disabled = !variant.available;
    button.textContent = variant.available ? addText : soldOutText;
   }

   if (status) {
    status.hidden = !!variant.available;
    status.textContent = variant.available ? '' : soldOutText;
   }

   if (price) price.textContent = money(variant.price);

   if (image && variant.image) {
    image.src = variant.image + (variant.image.indexOf('?') === -1 ? '?width=420' : '&width=420');
   }
  }

  function renderCrossSell(cart) {
   var crosssell = document.querySelector('[data-spx-crosssell]');
   var track = document.querySelector('[data-spx-crosssell-track]');
   if (!crosssell || !track) return;

   if (!cfgGet('show_crosssell') || !cart || !cart.items || cart.items.length === 0) {
    crosssell.hidden = true;
    track.innerHTML = '';
    return;
   }

   var baseProduct = cart.items[0];
   var productId = baseProduct.product_id;
   if (!productId) {
    crosssell.hidden = true;
    track.innerHTML = '';
    return;
   }

   fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + cfgGet('crosssell_limit') + '&intent=' + cfgGet('crosssell_intent'), {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
   })
   .then(function (response) {
    if (!response.ok) throw new Error('Recommendations error');
    return response.json();
   })
   .then(function (data) {
    var products = data && Array.isArray(data.products) ? data.products : [];
    var cartProductIds = cart.items.map(function (item) { return Number(item.product_id); });

    products = products.filter(function (product) {
     return cartProductIds.indexOf(Number(product.id)) === -1;
    }).slice(0, cfgGet('crosssell_limit'));

    if (!products.length) {
     crosssell.hidden = true;
     track.innerHTML = '';
     return;
    }

    track.innerHTML = products.map(function (product, index) {
     var variant = getFirstAvailableVariant(product);
     var image = variant && variant.image ? variant.image : product.featured_image || (product.images && product.images[0]) || '';
     var productUrl = product.url || '/products/' + product.handle;
     var title = escapeHTML(product.title);
     var price = variant ? money(variant.price) : '';
     var addText = cfgGet('crosssell_add_text') || 'AGREGAR';

     return (
      '<article class="spx-crosssell__card" data-spx-crosssell-card data-crosssell-index="' + index + '">' +
       '<a class="spx-crosssell__image" href="' + escapeHTML(productUrl) + '">' +
        (image ? '<img data-spx-crosssell-image src="' + escapeHTML(image) + (String(image).indexOf('?') === -1 ? '?width=420' : '&width=420') + '" alt="' + title + '" loading="lazy">' : '') +
       '</a>' +
       '<div class="spx-crosssell__info">' +
        '<a class="spx-crosssell__title" href="' + escapeHTML(productUrl) + '">' + title + '</a>' +
        '<div class="spx-crosssell__meta">' +
         '<span class="spx-crosssell__price" data-spx-crosssell-price>' + price + '</span>' +
         '<span class="spx-crosssell__status" data-spx-crosssell-status hidden></span>' +
        '</div>' +
        crosssellOptionsHTML(product) +
        '<button class="spx-crosssell__add" type="button" data-spx-crosssell-add="' + escapeHTML(variant ? variant.id : '') + '">' + escapeHTML(addText) + '</button>' +
       '</div>' +
      '</article>'
     );
    }).join('');

    crosssell.hidden = false;

    track.querySelectorAll('[data-spx-crosssell-card]').forEach(function (card) {
     var index = Number(card.getAttribute('data-crosssell-index'));
     var product = products[index];
     if (!product) return;

     card.querySelectorAll('[data-spx-crosssell-option]').forEach(function (select) {
      select.addEventListener('change', function () {
       updateCrosssellCard(card, product);
      });
     });

     updateCrosssellCard(card, product);
    });
   })
   .catch(function () {
    crosssell.hidden = true;
    track.innerHTML = '';
   });
  }

  function renderCart() {
   return fetch(getCartRoute('cart.js'), {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
   })
   .then(function (response) {
    if (!response.ok) throw new Error('Cart error');
    return response.json();
   })
   .then(function (cart) {
    updateCartCount(cart);
    updateFreeShipping(cart);

    var itemsWrap = document.querySelector('[data-spx-cart-items]');
    var subtotal = document.querySelector('[data-spx-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);

    renderCrossSell(cart);

    if (!itemsWrap) return;

    if (!cart.items || cart.items.length === 0) {
     itemsWrap.innerHTML = '<p class="spx-cart__empty">' + escapeHTML(cfgGet('empty_cart_text')) + '</p>';
     return;
    }

    itemsWrap.innerHTML = cart.items.map(function (item) {
     var image = item.image ? item.image : '';
     var title = escapeHTML(item.product_title);
     var url = item.url || '/cart';
     var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="spx-cart__item-variant">' + escapeHTML(item.variant_title) + '</div>'
      : '';

     return (
      '<div class="spx-cart__item" data-line="' + escapeHTML(item.key) + '">' +
       '<a href="' + escapeHTML(url) + '">' +
        (image ? '<img src="' + escapeHTML(image) + (String(image).indexOf('?') === -1 ? '?width=180' : '&width=180') + '" alt="' + title + '">' : '') +
       '</a>' +
       '<div>' +
        '<a class="spx-cart__item-title" href="' + escapeHTML(url) + '">' + title + '</a>' +
        variant +
        '<div class="spx-cart__qty">' +
         '<button type="button" data-spx-cart-qty="' + escapeHTML(item.key) + '" data-qty="' + Math.max(0, item.quantity - 1) + '">−</button>' +
         '<span>' + item.quantity + '</span>' +
         '<button type="button" data-spx-cart-qty="' + escapeHTML(item.key) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
        '</div>' +
       '</div>' +
       '<div class="spx-cart__item-price">' + money(item.final_line_price) + '</div>' +
      '</div>'
     );
    }).join('');
   })
   .catch(function () {});
  }

  function changeCartItem(key, quantity) {
   return fetch(getCartRoute('cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
   })
   .then(function (response) {
    if (!response.ok) throw new Error('Cart change error');
    return response.json();
   })
   .then(function (cart) {
    updateCartCount(cart);
    updateFreeShipping(cart);
    renderCart();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:change'));
   })
   .catch(function () {});
  }

  function addCrossSellProduct(variantId, button) {
   if (!variantId || !button || button.disabled) return;

   var originalText = button.textContent || (cfgGet('crosssell_add_text') || 'AGREGAR');
   button.textContent = cfgGet('crosssell_loading_text') || 'AGREGANDO...';
   button.disabled = true;

   return fetch(getCartRoute('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
   })
   .then(function (response) {
    if (!response.ok) throw new Error('Add error');
    return response.json();
   })
   .then(function () {
    button.textContent = cfgGet('crosssell_added_text') || 'AGREGADO';
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:change'));
    renderCart();
    window.setTimeout(function () {
     button.textContent = originalText;
     button.disabled = false;
    }, 900);
   })
   .catch(function () {
    button.textContent = cfgGet('crosssell_error_text') || 'ERROR';
    window.setTimeout(function () {
     button.textContent = originalText;
     button.disabled = false;
    }, 900);
   });
  }

  function initAnnouncementRotator(header) {
   var announcement = header.querySelector('[data-spx-announcement]');
   if (!announcement || announcement.dataset.ready === 'true') return;
   announcement.dataset.ready = 'true';

   var slides = Array.prototype.slice.call(announcement.querySelectorAll('[data-spx-announcement-slide]'));

   if (slides.length <= 1) return;

   var interval = Number(announcement.getAttribute('data-spx-announcement-interval')) || 4000;
   interval = Math.max(1500, interval);
   var current = 0;

   function showSlide(nextIndex) {
    current = (nextIndex + slides.length) % slides.length;
    slides.forEach(function (slide, index) {
     var isActive = index === current;
     slide.classList.toggle('is-active', isActive);
     slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
   }

   showSlide(0);
   window.setInterval(function () {
    showSlide(current + 1);
   }, interval);
  }

  function initHeader(header) {
   if (!header || header.dataset.ready === 'true') return;
   header.dataset.ready = 'true';

   initAnnouncementRotator(header);

   var mobileOpen = header.querySelector('[data-spx-mobile-open]');
   var mobileMenu = header.querySelector('[data-spx-mobile]');
   var searchOpen = header.querySelector('[data-spx-search-open]');
   var searchModal = header.querySelector('[data-spx-search]');

   if (mobileMenu) mobileMenu.hidden = true;
   if (searchModal) searchModal.hidden = true;

   if (mobileOpen && mobileMenu) {
    mobileOpen.addEventListener('click', function () {
     spxShowPanel(mobileMenu);
    });
   }

   if (searchOpen && searchModal) {
    searchOpen.addEventListener('click', function () {
     spxShowPanel(searchModal);

     var input = searchModal.querySelector('input[type="search"]');
     if (input) {
      setTimeout(function () {
       input.focus();
      }, 80);
     }
    });
   }
  }

  function handleDocumentClick(event) {
   var openTrigger = event.target.closest('[data-spx-cart-open]');
   if (openTrigger) {
    event.preventDefault();
    event.stopPropagation();
    SPXCart.open();
    return;
   }

   if (event.target.closest('[data-spx-cart-close]')) {
    event.preventDefault();
    SPXCart.close();
    return;
   }

   if (event.target.closest('[data-spx-mobile-close]')) {
    event.preventDefault();
    document.querySelectorAll('[data-spx-mobile]').forEach(function (el) {
     spxHidePanel(el);
    });
    return;
   }

   if (event.target.closest('[data-spx-search-close]')) {
    event.preventDefault();
    document.querySelectorAll('[data-spx-search]').forEach(function (el) {
     spxHidePanel(el);
    });
    return;
   }

   var qtyButton = event.target.closest('[data-spx-cart-qty]');
   if (qtyButton) {
    event.preventDefault();
    changeCartItem(qtyButton.getAttribute('data-spx-cart-qty'), qtyButton.getAttribute('data-qty'));
    return;
   }

   var crosssellButton = event.target.closest('[data-spx-crosssell-add]');
   if (crosssellButton) {
    event.preventDefault();
    event.stopPropagation();
    addCrossSellProduct(crosssellButton.getAttribute('data-spx-crosssell-add'), crosssellButton);
   }
  }

  function handleKeydown(event) {
   if (event.key === 'Escape') {
    document.querySelectorAll('[data-spx-mobile], [data-spx-search], [data-spx-cart]').forEach(function (el) {
     spxHidePanel(el);
    });
   }
  }

  SPXCart.refresh = async function () {
   return renderCart();
  };

  SPXCart.open = async function () {
   return openCart();
  };

  SPXCart.close = function () {
   closeCart();
  };

  SPXCart._handleClick = handleDocumentClick;
  SPXCart._handleKeydown = handleKeydown;
  SPXCart._refreshFromEvent = renderCart;

  if (SPXCart._listenersReady !== true) {
   document.addEventListener('click', function (event) {
    if (window.SPXCart && typeof window.SPXCart._handleClick === 'function') {
     window.SPXCart._handleClick(event);
    }
   }, true);

   document.addEventListener('keydown', function (event) {
    if (window.SPXCart && typeof window.SPXCart._handleKeydown === 'function') {
     window.SPXCart._handleKeydown(event);
    }
   });

   ['cart:refresh', 'cart:updated', 'cart:change', 'ajaxCart:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
     if (window.SPXCart && typeof window.SPXCart._refreshFromEvent === 'function') {
      window.SPXCart._refreshFromEvent();
     }
    });
   });

   SPXCart._listenersReady = true;
  }

  SPXCart._bootAllHeaders = function () {
   document.querySelectorAll('[data-spx-header]').forEach(initHeader);
   renderCart();
  };

  SPXCart._bootLoadedSection = function (event) {
   var header = event.target.querySelector('[data-spx-header]');
   if (header) {
    header.dataset.ready = 'false';
    initHeader(header);
    renderCart();
   }
  };

  if (SPXCart._bootListenersReady !== true) {
   document.addEventListener('DOMContentLoaded', function () {
    if (window.SPXCart && typeof window.SPXCart._bootAllHeaders === 'function') {
     window.SPXCart._bootAllHeaders();
    }
   });

   document.addEventListener('shopify:section:load', function (event) {
    if (window.SPXCart && typeof window.SPXCart._bootLoadedSection === 'function') {
     window.SPXCart._bootLoadedSection(event);
    }
   });

   SPXCart._bootListenersReady = true;
  }

  if (document.readyState !== 'loading') {
   SPXCart._bootAllHeaders();
  }

  window.spxOpenCart = SPXCart.open;
  window.spxRenderCart = SPXCart.refresh;
 })();
